import useGetProductPriceRangeByCategory from './useGetProductPriceRangeByCategory'

export default useGetProductPriceRangeByCategory
